/*
 * @Description: 侧边栏
 * @Author: Lxc 1533761120@qq.com
 * @Date: 2024-06-05 11:12:11
 * @LastEditors: Lxc 1533761120@qq.com
 * @LastEditTime: 2025-07-15 18:11:29
 */

import { SERVICE_CODE_URLS } from '@/constants/serviceCode'

export interface NavItem {
  label: string
  /** 是否显示该菜单项 */
  show: boolean
  /** s是否默认展开 */
  expand: boolean
  path: string
  canOpenPath?: boolean
  iconClassName: string
  name: string
  activeName: string[]
  key: string
  /** 菜单唯一标识，用于菜单高亮控制。如果不设置，则使用 key */
  menuKey?: string
  children?: NavItem[]
  serviceCodeUrl?: string
  disabled?: boolean
  isBeta?: boolean
  level?: number
  outerLink?: string
}

// 针对不同企业类型，呈现不同页面菜单：
// 1、工厂、原料等供应链，如原型；
// 2、品牌，去掉客户开发Agent，客户提案Agent改为产品提案Agent，企业资源中心在包材库下方婚加“工厂库”； 若客户多选企业类型，导出由靖姐确认。

export function isBrandEnterprise(enterpriseTypes?: string[]): boolean {
  if (!enterpriseTypes || enterpriseTypes.length === 0) {
    return false
  }
  return enterpriseTypes.includes('BRAND')
}

export const createNavList = ({ enterpriseTypes, isPersonal, hasMarketAgentPermission }: { enterpriseTypes?: string[]; isPersonal: boolean; hasMarketAgentPermission: boolean }): NavItem[] => {
  return [
    {
      label: '首页',
      show: true,
      expand: false,
      path: '/workbench',
      iconClassName: 'icon-home',
      name: 'WorkbenchView',
      activeName: ['WorkbenchView'],
      key: 'home',
      level: 1,
    },
    {
      label: '数据洞察',
      show: true,
      expand: true,
      path: '/data-system',
      iconClassName: 'icon-insight',
      name: 'DataSystem',
      activeName: ['DataSystem'],
      key: 'DataSystem',
      level: 1,
      canOpenPath: true,
      children: [
        {
          label: '美业数据大脑',
          show: true,
          expand: false,
          path: '/meiye-v2',
          iconClassName: '',
          name: 'MeiyeV2',
          activeName: ['MeiyeV2'],
          key: 'meiye-v2',
          level: 2,
          outerLink: '',
          serviceCodeUrl: SERVICE_CODE_URLS['meiye-v2'],
        },
        {
          label: '宣称趋势洞察',
          show: true,
          expand: false,
          path: '/ct',
          iconClassName: '',
          name: 'Ct',
          activeName: ['Ct'],
          key: 'ct',
          level: 2,
          outerLink: '',
          serviceCodeUrl: SERVICE_CODE_URLS['ct'],
        },
        {
          label: '全球新品洞察',
          show: true,
          expand: false,
          path: '/np',
          iconClassName: '',
          name: 'Np',
          activeName: ['Np'],
          key: 'np',
          level: 2,
          outerLink: '',
          serviceCodeUrl: SERVICE_CODE_URLS['np'],
        },
        {
          label: '报告洞察',
          show: true,
          expand: false,
          path: '/rpt',
          iconClassName: '',
          name: 'Rpt',
          activeName: ['Rpt'],
          key: 'rpt',
          level: 2,
          outerLink: '',
          serviceCodeUrl: SERVICE_CODE_URLS['report'],
        }, {
          label: '更多',
          show: true,
          expand: true,
          path: '/data-system',
          iconClassName: 'icon-insight',
          name: 'MoreDataSystem',
          activeName: ['MoreDataSystem'],
          key: 'MoreDataSystem',
          level: 2,
        }

      ],
    },
    {
      label: '美业Agents',
      show: true,
      expand: true,
      path: '/market-agents',

      iconClassName: 'icon-ai',
      name: 'EnterpriseAiAgents',
      activeName: ['EnterpriseAiAgents'],
      key: 'enterprise-ai-agents',
      level: 1,
      children: [
        {
          label: '市场调研Agent',
          show: true,
          expand: false,
          path: '/market-agent',
          iconClassName: '',
          name: 'MarketAgent',
          activeName: ['MarketAgent'],
          key: 'MarketAgent',
          isBeta: false,
          level: 2,
          // disabled: !hasMarketAgentPermission,
        },
        {
          label: isBrandEnterprise(enterpriseTypes) ? '产品提案Agent' : '客户提案Agent',
          show: !isBrandEnterprise(enterpriseTypes),
          expand: false,
          path: isBrandEnterprise(enterpriseTypes) ? '/productManage' : '/customer-proposal-agent',
          iconClassName: '',
          name: isBrandEnterprise(enterpriseTypes) ? 'ProductManageView' : 'CustomerProposalAgent',
          activeName: isBrandEnterprise(enterpriseTypes) ? ['ProductManageView'] : ['CustomerProposalAgent'],
          key: isBrandEnterprise(enterpriseTypes) ? 'ProductManageView' : 'CustomerProposalAgent',
          isBeta: true,
          level: 2,
        },
        {
          label: '原料Agent',
          show: true,
          expand: false,
          path: '/supply-chain-agent',
          iconClassName: '',
          name: 'SupplyChainAgent',
          activeName: ['SupplyChainAgent'],
          key: 'SupplyChainAgent',
          disabled: true,
          level: 2,
        },
      ],
    },
    {
      label: '供应链库',
      show: true,
      expand: true,
      path: '/data-chain-base',
      iconClassName: 'icon-chain',
      name: 'DataChainBase',
      activeName: ['DataChainBase'],
      key: 'data-chain-base',
      level: 1,
      children: [
        {
          label: '需求大厅',
          show: true,
          expand: false,
          path: '/demand-hall',
          iconClassName: '',
          name: 'DemandHall',
          activeName: ['DemandHall'],
          key: 'dssc',
          menuKey: 'dssc-demand-hall',
          level: 2,
          outerLink: '/#/demand-hall',
          serviceCodeUrl: SERVICE_CODE_URLS['dssc'],
        },
        {
          label: '提案广场',
          show: true,
          expand: false,
          path: '/proposal-square',
          iconClassName: '',
          name: 'ProposalSquare',
          activeName: ['ProposalSquare'],
          key: 'proposal-square',
          level: 2,
        },
        {
          label: '原料库',
          show: true,
          expand: false,
          path: '/material-library-china',
          iconClassName: '',
          name: 'MaterialLibraryChina',
          activeName: ['MaterialLibraryChina'],
          key: 'dssc',
          menuKey: 'dssc-material',
          level: 2,
          outerLink: '/#/material',

          serviceCodeUrl: SERVICE_CODE_URLS['dssc'],
        },
        {
          label: '工厂库',
          show: true,
          expand: false,
          path: '/factory-library-china',
          iconClassName: '',
          name: 'FactoryLibraryChina',
          activeName: ['FactoryLibraryChina'],
          key: 'dssc',
          menuKey: 'dssc-factory',
          level: 2,
          outerLink: '/#/factory',
          serviceCodeUrl: SERVICE_CODE_URLS['dssc'],
        },
      ],
    },
    {
      label: '知识中心',
      show: true,
      expand: true,
      // path: '/knowledgeBase',
      path: '/knowledge',
      iconClassName: 'icon-knowledge', // icon-knowledge
      name: 'Knowledge',
      activeName: [''],
      key: 'knowledge',
      level: 1,
      children: [
        {
          label: '平台知识库',
          show: true,
          expand: false,
          path: '/platform-knowledge-search',
          iconClassName: '',
          name: 'PlatformKnowledgeSearch',
          activeName: ['PlatformKnowledge', 'PlatformKnowledgeSearch'],
          key: 'platform-knowledge',
          level: 2,
        },
        {
          label: isPersonal ? '个人知识库' : '企业知识库',
          show: true,
          expand: false,
          // path: '/knowledgeBase',
          path: '/knowledge',
          iconClassName: 'icon-knowledge',
          name: 'Knowledge',
          activeName: ['KnowledgeBaseView', 'KnowledgeFolderiew', 'KnowledgeInFolderiew', 'KnowledgeFileView', 'Knowledge'],
          key: 'knowledge',
          level: 2,
        },
        {
          label: '企业收藏',
          show: !isPersonal,
          expand: false,
          path: '/knowledge-collection',
          iconClassName: 'icon-knowledge',
          name: 'KnowledgeCollection',
          activeName: ['KnowledgeCollection'],
          key: 'knowledge-collection',
          level: 2,
        },
      ],
    },
  ]
}
